export default {
  PRODUCT_REPEATER_CLASS: 'd-grid grid-2 grid-md-3 grid-lg-4 grid-gap-15',
};
